import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPerfilLoja } from '../../services/perfilService';
import Calculater from '../../components/calculater/calculater';
import './index.css';
import { motion, AnimatePresence } from 'framer-motion';

export default function PerfilCalculaterLoja() {
  const { storeId } = useParams();
  const [perfil, setPerfil] = useState(null);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    if (storeId) {
      getPerfilLoja(storeId).then(setPerfil);
    }

    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [storeId]);

  return (
    <AnimatePresence mode="wait">
      {showSplash ? (
        <motion.div
          key="splash"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          style={{
            backgroundColor: '#ffffff',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
        >
          <img
            src="https://storage.googleapis.com/flutterflow-io-6f20.appspot.com/projects/i-troca-qkfavh/assets/yfki2lz2mcww/iTroca_-_PRETO_(1).png"
            alt="iTroca logo"
            style={{ width: '250px', objectFit: 'contain' }}
          />
        </motion.div>
      ) : perfil ? (
        <motion.div
          key="conteudo"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="perfil-container"
        >
          <div className="perfil-header">
            <div className="perfil-header-content">
              <div className="perfil-avatar">
                <img src={perfil.photo_url || '/logo192.png'} alt="Logo da loja" />
              </div>
              <div className="perfil-info">
                <h2>{perfil.nomeLoja}</h2>
                <div className="perfil-stars">⭐⭐⭐⭐⭐</div>
                <span className="perfil-type">{perfil.categoria}</span>
              </div>
            </div>
          </div>

          <Calculater perfil={perfil} />

          <div className="perfil-avaliacoes">
            <h3>AVALIAÇÕES</h3>
            <div className="sem-avaliacoes">
              A loja ainda não possui avaliações na plataforma!
            </div>
            <button className="avaliar-button">Avaliar loja</button>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
